import { Clock } from "lucide-react";
import { LucideProps } from "lucide-react";

interface HistoryIconProps extends LucideProps {
  className?: string;
}

export default function HistoryIcon({ className = "", size = 24, ...props }: HistoryIconProps) {
  return <Clock className={className} size={size} {...props} />;
}
